<template>
  <div class="resume">
    <p class="resume__title">La tua scelta:</p>

    <div class="resume__row">
      <span>1x</span>
      <span class="resume__product">{{ product.name }}</span>
    </div>

    <div class="resume__row resume__row--total">
      <span>Totale</span>
      <span class="resume__amount">€ {{ selected_amount }}</span>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';

  export default {
    name: 'resume',

    computed: {
      ...mapState('livegift', ['selected_amount']),
      ...mapGetters('livegift', { product: 'selected_product_data' }),
    },
  };
</script>

<style lang="scss" scoped>

  // riepilogo dello slot #resume della sidebar: la card bianca se la porta il
  // blocco, come fa resume.vue di liveeps (lo stile .vb-sidebar__block è scoped
  // dentro sidebar.vue e non arriva al contenuto degli slot)
  .resume {
    padding: $grid-gutter-20;
    margin-bottom: $grid-gutter-20;
    background-color: $white;
    border-radius: $border-radius-lg * 2;

    &__title {
      margin: 0;
      font-size: $font-size-base;
      font-weight: $vb-font-weight-semibold;
      color: $gray-900;
    }

    &__row {
      display: flex;
      justify-content: space-between;
      margin-top: $grid-gutter-width / 2;
      font-size: $font-size-md;
      font-weight: $vb-font-weight-semibold;
      color: $gray-900;
    }

    &__product {
      text-align: right;
    }

    // il totale è separato dalla riga del prodotto da un filetto
    &__row--total {
      padding-top: $grid-gutter-width / 2;
      border-top: $border-width solid $gray-300;
    }

    &__amount {
      font-weight: $font-weight-normal;
    }
  }
</style>